import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { ChartContainer, ChartTooltipContent } from '../ui/chart';

export type ConditionDatum = { name: string; value: number };

const COLORS = ['#16a34a', '#0ea5e9', '#f59e0b', '#ef4444'];

export default function ConditionDonutChart({ data }: { data: ConditionDatum[] }) {
  return (
    <ChartContainer className="h-64">
      <ResponsiveContainer>
        <PieChart>
          <Pie data={data} innerRadius={60} outerRadius={90} paddingAngle={2} dataKey="value">
            {data.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<ChartTooltipContent />} />
        </PieChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
}


